import { render, staticRenderFns } from "./LinguaModalEditComponent.vue?vue&type=template&id=9f69404c"
import script from "./LinguaModalEditComponent.vue?vue&type=script&lang=js"
export * from "./LinguaModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports